import {Dialog} from "./common";
import {getDateEditFormat} from "../operations/formats";
import {getJsDateFromExcel, getExcelDateFromJs} from "../mathematics/methods";
import {isDateInvalid} from "../operations/formats";
import {find} from "../helpers/array";
import group from "../operations/undo_group";

export const action = "add-cell-validation";

export class DialogBox extends Dialog{
	$show(box, form){
		const cell = this.cell = this.view.getSelectedId();
		if(!cell)
			return false;

		this.restoreValue(form, cell);

		this.view.$handleSelection = (st, end, a, b)=>{
			const type = this.$dialog.getBody().elements.type.getValue();
			if (this.activeValue && this.activeValue.isVisible()){
				if(type == "range"){
					const span = this.view.$$("cells").getSpan(st.row, st.column);
					if(span && st.row+span[3]*1-1 == end.row && st.column+span[2]*1-1 == end.column)
						b = a;
				}
				this.activeValue.setValue("="+(type != "range" ? a : a+":"+b));
			}
			return false;
		};
	}
	$hide(){
		this.view.$handleSelection = null;
		this.$dialog.getBody().clear();
	}
	restoreValue(form, cell){
		let rule = this.view.validation.get(cell.row, cell.column);
		if(!rule)
			rule = {};
		webix.extend(rule, { type: "any", errorHandle: "information" });
		form.setValues(rule);
		this.formatInput(form.elements.value);
		this.formatInput(form.elements.value2);
	}
	prepareConditions(){
		const handlers = this.view.validation.handlers;
		for(let name in handlers)
			handlers[name].map(rule => {
				if(!rule.value)
					rule.value = webix.i18n.filter[ rule.id ];
				return rule;
			});
		this.handlers = handlers;
	}
	handleTypeChange(value, oldValue){
		const form = this.$dialog.getBody();
		const elements = form.elements;

		const type = elements.type.getValue();
		const condition = elements.condition;

		switch(type){
			case "any":
				form.showBatch("any");
				break;
			case "date":
			case "text":
			case "textLength":
				form.showBatch("value");
				form.showBatch("condition", true);
				break;
			case "number":
				form.showBatch("value");
				form.showBatch("condition", true);
				form.showBatch("number", true);
				break;
			case "range":
				form.showBatch("value");
				break;
		}

		const conditionValue = condition.getValue();
		if(condition.isVisible()){
			condition.getList().clearAll();
			const data = [...this.handlers[type]];

			if(!find(data, obj => obj.id == conditionValue))
				condition.setValue();

			condition.getList().parse(data);

			if(conditionValue == "between" || conditionValue == "notBetween")
				elements.value2.show();
			else
				elements.value2.hide();
		}
		else
			elements.value2.hide();

		const locale = webix.i18n.spreadsheet.labels;
		const placeholders = {
			text: locale["validation-placeholder-text"] || "some text",
			textLength: locale["validation-placeholder-number"] || 123,
			date: locale["validation-placeholder-date"] || getDateEditFormat(this.view, this.cell.row, this.cell.column)(new Date()),
			number: locale["validation-placeholder-number"] || 123,
			range: locale["validation-placeholder-range"] || "=A1:A7"
		};

		elements.value.config.placeholder = elements.value2.config.placeholder = placeholders[type];

		if(oldValue == "date"){
			elements.value.setValue(this.normalizeValue(elements.value.getValue(), "date"));
			elements.value2.setValue(this.normalizeValue(elements.value2.getValue(), "date"));
		}
		else if(value == "date"){
			this.formatInput(elements.value);
			this.formatInput(elements.value2);
		}

		elements.value.refresh();
		elements.value2.refresh();
	}
	normalizeValue(value, type){
		if(webix.isUndefined(value))
			value = "";

		const isString = isNaN(value);
		if(isString && value[0] == "=")
			return value;

		type = type || this.$dialog.getBody().elements.type.getValue();
		if(type == "date"){
			if(isString){
				const parser = webix.Date.strToDate( webix.i18n.spreadsheet.formats.parseDateTime );
				value = parser(value);
				value = value === "" || isNaN(value) ? "" : getExcelDateFromJs(value);
			}
			else
				value = isDateInvalid(value) ? "" : value;
		}
		else if((type == "number" || type == "textLength") && isString)
			value = "";

		return value;
	}
	formatValue(value, type){
		if(type == "date" && value !== "" && value[0] != "="){
			value = getJsDateFromExcel(value);
			return getDateEditFormat(this.view, this.cell.row, this.cell.column)(value);
		}
		return value.toString();
	}
	formatInput(view){
		let value = view.getValue();
		if(value !== ""){
			const elements = view.getFormView().elements;
			const type = elements.type.getValue();
			value = this.normalizeValue(value, type);
			view.setValue(this.formatValue(value, type));
		}
	}
	$init(){
		this.prepareConditions();
		const locale = webix.i18n.spreadsheet.labels;

		return {
			view: "ssheet-dialog",
			width: 500,
			head: locale["add-cell-validation"],
			move: true,
			position: "center",
			body:{
				view:"form",
				elementsConfig: {
					labelWidth: 170
				},
				rules:{
					value: webix.rules.isNotEmpty,
					value2: webix.rules.isNotEmpty,
					condition: webix.rules.isNotEmpty,
					errorHandle: webix.rules.isNotEmpty
				},
				elements:[
					{ view:"richselect", label:locale["validation-type"], name:"type",
						options:[
							{id:"any", value:locale["validation-any"]},
							{id:"date", value:locale["validation-date"]},
							{id:"number", value:locale["validation-number"]},
							{id:"text", value:locale["validation-text"]},
							{id:"textLength", value:locale["validation-text-length"]},
							{id:"range", value:locale["validation-range"]}
						],
						on: {
							onChange: (value, oldValue) => this.handleTypeChange(value, oldValue)
						}
					},
					{ view:"checkbox", label:locale["validation-integer"], batch:"number", name:"integer" },
					{ view:"checkbox", label:locale["validation-ignore-empty"], batch:"value", name:"ignoreEmpty" },
					{
						label:locale["condition"],
						required: true,
						batch:"condition",
						view:"richselect",
						name: "condition",
						on: {
							onChange: function(newv) {
								const elements = this.getFormView().elements;
								if (newv == "between" || newv == "notBetween")
									elements.value2.show();
								else
									elements.value2.hide();
								elements.condition.validate();
							}
						},
						suggest:{
							view: "ssheet-form-suggest",
							body:{
								data: []
							}
						}
					},
					{
						batch:"value",
						cols: [
							{
								label:locale["value"],
								required: true,
								view: "text",
								on: {
									onFocus: current_view => this.activeValue = current_view,
									onBlur: current_view => {
										this.formatInput(current_view);
										current_view.validate();
									}
								},
								name: "value"
							},
							{
								view: "text",
								required: true,
								name: "value2",
								width: 150,
								on: {
									onFocus: current_view => this.activeValue = current_view,
									onBlur: current_view => {
										this.formatInput(current_view);
										current_view.validate();
									}
								},
								hidden: true
							}
						]
					},
					{
						name: "inputMessage",
						view: "textarea",
						label: locale["validation-input-message"]
					},
					{ view:"richselect", batch:"value", label:locale["validation-error-handle"], name:"errorHandle",
						options:[
							{id:"information", value:locale["validation-error-information"]},
							{id:"warning", value:locale["validation-error-warning"]},
							{id:"stop", value:locale["validation-error-stop"]}
						],
						on:{
							onChange: function(){
								this.validate();
							}
						}
					},
					{
						name: "errorTitle",
						view: "text",
						batch:"value",
						label: locale["validation-error-title"]
					},
					{
						name: "errorMessage",
						view: "textarea",
						batch:"value",
						label: locale["validation-error-message"]
					}
				]
			},
			on:{
				onSaveClick: () => this.okClick(),
				onCancelClick: () => this.close()
			}
		};
	}
	okClick(){
		const form = this.$dialog.getBody();
		if(form.validate()){
			const data = form.getValues({hidden:false});
			data.value = this.normalizeValue(data.value);
			if(data.value2){
				data.value = [data.value, this.normalizeValue(data.value2)];
				delete data.value2;
			}

			const view = this.view;
			group.set(()=>
				view.eachSelectedCell(cell =>{
					if(data.type == "any" && !data.inputMessage)
						view.validation.remove(cell.row, cell.column);
					else
						view.validation.add(cell.row, cell.column, data);
				})
			);

			view.refresh();
			this.close();
		}
	}
}